import { useContext, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useParams } from 'react-router-dom';
import Loader from 'components/loader/Loader';
import RetryPanel from 'containers/partials/error-boundary/RetryPanel';
import usePostMessage from 'hooks/utils/usePostMessage';
import { useIntl } from 'react-intl';
import messages from 'messages';
import useQuestionnaires from 'hooks/queries/useQuestionnaires';
import { useStore } from 'stores/Store';
import Questionnaires from './Questionnaires';

const OverviewQuestionnaires = () => {
  const intl = useIntl();
  const { entityId } = useParams();
  const { fetchQuestionnaires, loading, error } = useQuestionnaires({
    entityId
  });
  const { sendMessage } = usePostMessage();
  const reports = useStore(state => state.reports);
  useEffect(() => {
    const fetchData = async () => {
      await fetchQuestionnaires();
    };

    fetchData().catch(error => {
      Sentry.captureException(error);
    });
  }, []);

  useEffect(() => {
    const data = {
      title: intl.formatMessage(messages.titleQuestionnaires),
      description: intl.formatMessage(messages.questionnairesSubtitleAll),
      canGoBack: false
    };
    sendMessage({ message: data });
  }, []);

  if (loading || reports === null) return <Loader />;
  if (error) return <RetryPanel />;

  return <Questionnaires entityId={entityId} />;
};

export default OverviewQuestionnaires;
